import React from 'react';
import { Divider } from 'semantic-ui-react';

export default function HomePage() {

  return (
    <React.Fragment>
      Welcome in Payair Demoshop!
      <Divider hidden/>
    </React.Fragment>
  );
}